import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {filter, map} from "rxjs/operators";
import {BaseComponent} from "../base.component";
import {LoggerService} from "../common/logger.service";
import {UserService} from "../common/user.service";
import {Constants} from "../constants";
import {NavigationService} from "../common/navigation.service";
import {NavigationStart} from "@angular/router";

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent extends BaseComponent implements OnInit {

    headerType$: Observable<string>;
    customStyle: string;

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private navigationService: NavigationService
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.headerType$ = this.navigationService.navigationStartSubject.watch().pipe(
            filter(value => value !== null),
            map((event: NavigationStart) => {
                const cleanUrl = event?.url.split('?')[0];
                const stripBase = (route: string) => route.replace(`/${Constants.URL_BASE_CART}`, '');
                this.log.debug(`Processing navigation event for URL: ${cleanUrl} , ${this.CHECKOUT_ROUTE}`);
                switch (true) {
                    //Header route check
                    case cleanUrl.endsWith(stripBase(this.ENROLL_ASSOCIATE_ROUTE)):
                        return Constants.ENROLL_ASSOCIATE_STATE;
                    case cleanUrl.endsWith(stripBase(this.CHECKOUT_ROUTE)):
                        return Constants.CHECKOUT_STATE;
                    case cleanUrl.includes(stripBase(this.PAYMENT_CALLBACK_ROUTE)):
                    case cleanUrl.includes(stripBase(this.CHECKOUT_CONFIRM_ROUTE)):
                        this.customStyle = "offset-content";
                        return Constants.CHECKOUT_STATE;
                    default:
                        return "main";
                }
            })
        );
    }

}
